import RegistrationOrderLineItem from "../events/event/packages/registration-order-line-item";
import { useTheme } from "../../hooks/themeHooks";
import {
  defaultBorders,
  defaultLayouts,
  defaultPadding,
  GSItemList,
} from "golfstatus_react_components";
import { useDispatch, useSelector } from "react-redux";
import {
  removeDonationOrderItemThunk,
  selectRegistrationOrder,
} from "../../reducers/registrationOrderSlice";
import { useGolfstatusNavigate } from "../../hooks/navigationHooks";

const CartDonationWidget = () => {
  const [, theme, getStyle] = useTheme();

  const dispatch = useDispatch();

  const navigate = useGolfstatusNavigate();

  const registrationOrder = useSelector(selectRegistrationOrder);

  const donations = registrationOrder?.donationOrderItems?.filter?.(
    (d) => !d.roundUp
  );

  const item = (donation) => {
    return {
      quantity: 1,
      tournamentPackage: {
        name: "Donation",
        cost: donation.amount,
      },
    };
  };

  const removeDonation = (donation) => {
    dispatch(removeDonationOrderItemThunk(donation));
  };

  return (
    <GSItemList
      type="vertical large-gap"
      style={{...defaultLayouts.fullWidth}}
      items={donations}
      listItem={(donation) => (
        <RegistrationOrderLineItem
          donation={donation}
          style={{
            ...defaultLayouts.fullWidth,
            ...getStyle(theme.surfaceVariant),
            ...defaultPadding.xLargePad,
            ...defaultBorders.largeBorderRadius,
          }}
          removePackage={() => {
            removeDonation(donation);
          }}
          formSelected={() => {
            navigate(`donation/message?id=${donation.id}`);
          }}
          {...item(donation)}
        />
      )}
    ></GSItemList>
  );
};

export default CartDonationWidget;
